
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { WoService } from '../../work-order/work-order.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../shared.service';
import { DatePipe } from '@angular/common';
import { BaseComponent } from '../base.component';
import { LoaderService } from '../loader.service';
import { ProjectDetailsPanelEntity, RoleAccess } from '../shared.model';

@Component({
    selector: 'project-detail-panel',
    templateUrl: 'project-details-panel.component.html',
})

export class ProjectDetailPanelComponent extends BaseComponent implements OnInit {
    @Input() workorderId: number = 0;
    @Input() Rights: RoleAccess = new RoleAccess();
    model: ProjectDetailsPanelEntity = new ProjectDetailsPanelEntity();
    ifLoaded: boolean = false;
    constructor(protected translateService: TranslateService, protected _woService: WoService,
        protected sharedService: SharedService, private loaderService: LoaderService,
        private datePipe: DatePipe) {
        super(sharedService, translateService)
        //Table paginations

    }
    ngOnInit() {      
        if (this.Rights && this.Rights.ViewRights == 1) 
            this.GetProjectDetailsPanel();
        
    }

    GetProjectDetailsPanel() {
        this.loaderService.show();
        this._woService.GetProjectDetailsPanel(this.globalInfo().CompanyId, this.workorderId).subscribe(
            s => {
                this.loaderService.hide();
                this.ifLoaded = true;               
                this.model = s;
            },
            e => {
                this.loaderService.hide();
            }
        );
    }
}